import { Controller } from "stimulus"
import i18next from "i18next"

export default class extends Controller {
  static targets = ["message", "actions", "listElement", "selectionHint"]

  connect() {}

  messageToggle() {
    if (this.selectedElements.length > 0) {
      this.actionsTarget.classList.remove("d-none")
      this.messageTarget.classList.add("d-none")
    } else {
      this.actionsTarget.classList.add("d-none")
      this.messageTarget.classList.remove("d-none")
    }
  }

  selectAll(event) {
    this.listElementTargets.forEach(el => el.checked = event.target.checked)
  }

  updateSelectionHint() {
    const translationKey = this.selectionHintTarget.dataset["elementsType"] + ".selectedCount"
    this.selectionHintTarget.innerHTML = i18next.t(translationKey, {
      count: this.selectedElements.length,
    })
  }

  get selectedElements() {
    return this.listElementTargets.filter(function(el) {
      if (el.checked) {
        return el
      }
    })
  }
}
